import { GsFormSchema } from '../../../components';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { DISPLAY_MODE_SCHEMA } from './../basics/display-mode.schema';
import { SPACING_SCHEMA } from './spacing.schema';

export const FAQ_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ACTIVE_SCHEMA_FIELDS,
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    ...DISPLAY_MODE_SCHEMA,
    {
      formControlName: 'pageSize',
      label: 'schema.items.pageSize',
      type: 'number',
      default: 9999,
      min: 1,
      groupingName: 'schema.items.name'
    }
  ]
};
